export const SITE_BRAND = 'SaveItPro';
export const SITE_NAME = `${SITE_BRAND} Tools`;
export const SITE_TAGLINE =
  'Free online tools for media conversion, text formatting, JSON utilities, JavaScript, arrays, and time calculations';

export const SITE_URL =
  process.env.REACT_APP_SITE_URL?.replace(/\/$/, '') || 'https://www.saveitpro.com';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') || 'https://backend.saveitpro.com';

export const BLOG_API_BASE_URL =
  process.env.REACT_APP_BLOG_API_BASE_URL?.replace(/\/$/, '') ||
  'https://blog.backend.saveitpro.com';

/** Full path prefix for media API */
export const MEDIA_API_PREFIX = `${API_BASE_URL}/v1/api/media`;

/** Full path prefix for blog API */
export const BLOG_API_PREFIX = `${BLOG_API_BASE_URL}/v1/api/blogs`;
